import { Edit, SimpleForm } from 'react-admin';
import { MyFormContainer, MyToolbar } from '@/components/forms';
import { QrCodeFormFields } from './QrCodeForm';

export const QrCodeEdit = () => {
  const transform = (data: Record<string, any>) => {
    const { no_expiry: noExpiry, ...rest } = data;
    if (noExpiry) rest.qr_end_time = 'never';
    return rest;
  };

  return (
    <Edit redirect="list" mutationMode="pessimistic" transform={transform}>
      <SimpleForm toolbar={<MyToolbar resource="qrcodes" />}>
        <MyFormContainer>
          <QrCodeFormFields isCreate={false} />
        </MyFormContainer>
      </SimpleForm>
    </Edit>
  );
};

export default QrCodeEdit;
